webpackJsonp([215],{

/***/ 1140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "vue-loader autoprefix 推荐配置 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1955:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1140),
  /* template */
  __webpack_require__(2252),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/vue-loader-autoprefix-161.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] vue-loader-autoprefix-161.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-56593d7b", Component.options)
  } else {
    hotAPI.reload("data-v-56593d7b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2252:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("autoprefix 推荐配置")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("vue")]), _vm._v("官方模板的设置是"), _c('code', [_vm._v("last 2 versions")]), _vm._v("，可能会导致你在某些"), _c('code', [_vm._v("Android")]), _vm._v("机子上出现问题。")]), _vm._v(" "), _c('p', [_vm._v("如果你使用 "), _c('code', [_vm._v("last 7 versions")]), _vm._v(" 会生成不必要的"), _c('code', [_vm._v("-ms")]), _vm._v("前缀代码.")]), _vm._v(" "), _c('p', [_vm._v("因此建议同"), _c('code', [_vm._v("WeUI")]), _vm._v("一样，使用配置 "), _c('code', [_vm._v("['iOS >= 7', 'Android >= 4.1']")])]), _vm._v(" "), _c('h2', [_vm._v("直接在 vux-loader 里配置")]), _vm._v(" "), _c('p', [_vm._v("如果你没有在 postcss 里配置，你可以直接配置 vux-loader 的 "), _c('code', [_vm._v("duplicate-style")]), _vm._v(" 插件：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'duplicate-style'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("options")]), _vm._v(": {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("cssProcessorOptions")]), _vm._v(" : {\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("safe")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v(",\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("zindex")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("autoprefixer")]), _vm._v(": {\n        "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("add")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v(",\n        "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"browsers\"")]), _vm._v(": [\n          "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"iOS >= 7\"")]), _vm._v(",\n          "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"Android >= 4.1\"")]), _vm._v("\n        ]\n      }\n    }\n  }\n}\n")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-56593d7b", module.exports)
  }
}

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1955);

/***/ })

});


// WEBPACK FOOTER //
// 215.6af06510.js